"use strict";
/**
 * @name StepNav
 *
 * @description
 *  A component to render a 'wizard' like StepNav. This uses the <TextLink /> component for the nav links.
 *    See the Teamsnap patterns library for more information.  https://teamsnap-ui-patterns.netlify.com/patterns/components/step-nav.html
 *
 * @example
 *  <StepNav
 *    title='Test Title'
 *    steps={[
 *      { name: 'Step One', icon: 'home', linkProps: { onClick: (e) => { e.preventDefault(); console.warn('STEP 1 Click')}} },
 *      { name: 'Step Two', icon: 'roster', linkProps: { location: '/some-link-href' } },
 *      { name: 'Step Four', icon: 'messages' }
 *    ]} />
 *
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var PropTypes = __importStar(require("prop-types"));
var Icon_1 = require("../Icon");
var TextLink_1 = require("../TextLink");
var helpers_1 = require("../../utils/helpers");
var propTypes = {
    steps: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string.isRequired,
        icon: PropTypes.string.isRequired,
        isActive: PropTypes.bool,
        linkProps: PropTypes.object,
    })).isRequired,
    title: PropTypes.string,
    isSmall: PropTypes.bool,
    className: PropTypes.string,
    mods: PropTypes.string,
    style: PropTypes.object,
    testId: PropTypes.string,
    otherProps: PropTypes.object,
};
var StepNav = function (_a) {
    var steps = _a.steps, title = _a.title, isSmall = _a.isSmall, className = _a.className, mods = _a.mods, style = _a.style, testId = _a.testId, otherProps = _a.otherProps;
    var renderTitle = function () {
        return (React.createElement("div", { className: "StepNav-title" },
            React.createElement("h2", { className: "StepNav-titleText" }, title)));
    };
    var renderStep = function (step) {
        var name = step.name, icon = step.icon, isActive = step.isActive, linkProps = step.linkProps;
        var stepClasses = (0, helpers_1.getClassName)('StepNav-step', linkProps && 'is-enabled', linkProps && isActive && 'is-active');
        var LinkTag = linkProps ? TextLink_1.TextLink : 'span';
        return (React.createElement("li", { key: name, className: stepClasses },
            React.createElement(LinkTag, __assign({ className: "StepNav-stepLink" }, linkProps),
                React.createElement(Icon_1.Icon, { name: icon, mods: "StepNav-stepIcon" }),
                React.createElement("span", { className: "StepNav-stepTitle" }, name))));
    };
    var stepNavClass = (0, helpers_1.getClassName)(className, title && 'StepNav--titled', isSmall && 'StepNav--small', mods);
    return (React.createElement("div", __assign({ className: stepNavClass, style: style, "data-testid": testId }, otherProps),
        title && renderTitle(),
        React.createElement("ul", { className: "StepNav-steps" }, steps.map(function (step) { return renderStep(step); }))));
};
StepNav.defaultProps = {
    title: null,
    isSmall: false,
    className: 'StepNav',
    mods: null,
    style: {},
    testId: null,
    otherProps: {},
};
exports.default = StepNav;
